import React from "react";
import { Control } from "react-hook-form";
import { UseFormSelect } from "./UseFormSelect";
import { SxProps } from "@mui/material";

interface UseFormSelectDrive2Props {
  control: Control
  name: string
  sx: SxProps
}

export const UseFormSelectDrive2: React.FC<UseFormSelectDrive2Props> = ({
  control,
  name,
  sx = {}
}) => {
  return (
    <UseFormSelect
      control={control}
      name={name}
      items={[
        {value: '', label: ''},
        {value: '2WD', label: '2WD'},
        {value: '4WD', label: '4WD'},
      ]}
      sx={{
        width: '100px',
        ...sx,
      }}
    />
  )
}